<div>
  <div
    class="modal-table position-relative"
    [class.user]="isFromModal"
    infiniteScroll
    (scrolled)="onScroll()"
    [scrollWindow]="false"
  >
    <ng-container *ngIf="accounts; else loading">
      <table class="standart-table" *ngIf="accounts.length; else emptyAccounts">
        <thead class="standart-table-header">
          <tr>
            <th style="width: 70%">Account name</th>
            <th style="width: 30%">Account number</th>
            <th style="width: 60px">
              <div class="d-flex" *ngIf="!isAccountsSelected">
                <label class="checkbox ml-auto">
                  <input
                    type="checkbox"
                    (change)="toggleAllAccounts($event)"
                    [checked]="isAllAccountsChacked"
                  />
                </label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let account of accounts">
            <td class="no-wrap">{{ account.name }}</td>
            <td>{{ account.accountNumber }}</td>
            <td class="actions-cell">
              <div class="d-flex">
                <label class="checkbox ml-auto" *ngIf="!isAccountsSelected">
                  <input
                    type="checkbox"
                    (change)="onAccountCheckboxChange(account)"
                    [checked]="account.checked"
                  />
                </label>

                <a
                  href="javascript:void(0);"
                  class="standart-link-action red ml-auto"
                  [class.disabled]="disabled"
                  (click)="onAccountDelete(account)"
                  *ngIf="isAccountsSelected"
                >
                  <i class="fas fa-times-circle"></i>
                </a>
              </div>
            </td>
          </tr>

          <tr *ngIf="isAccountsLoading">
            <td colspan="3">
              <div class="d-flex w-100 h-100">
                <loader></loader>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>

  <div
    class="d-flex mt-3"
    *ngIf="
      checkedAccounts &&
      checkedAccounts.length > 0 &&
      !isAccountsSelected &&
      !isFromModal
    "
  >
    <button class="button w-134px ml-auto" (click)="onAccountApplay()">
      Apply
    </button>
  </div>
</div>

<ng-template #loading>
  <loader style="min-height: 180px"></loader>
</ng-template>

<ng-template #emptyAccounts>
  <div
    class="d-flex justify-content-center align-items-center text-center"
    style="min-height: 180px"
  >
    <empty-state size="sm" title="No Account(s) Yet" [text]="emptyText">
    </empty-state>
  </div>
</ng-template>
